import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import WidgetCard from './WidgetCard';
import { NestedMenuOptionT } from 'ui/NestedMenu/NestedMenu';

type Props = {
    editMode: boolean;
    canEdit: boolean;
    menuItems: NestedMenuOptionT[];
    isPdfModeActivated: boolean;
};

const PageBreakWidget: React.FC<Props> = ({
    editMode,
    menuItems,
    canEdit,
    isPdfModeActivated,
}) => {
    const { t } = useTranslation();
    return (
        <WidgetCard
            editMode={editMode}
            menuItems={menuItems}
            canEdit={canEdit}
            transparent={isPdfModeActivated}
        >
            <Typography
                // NOTE: this behavior is based on a css class defined in WidgetCard
                className="showOnHover"
                sx={{
                    textAlign: 'center',
                    color: (theme) => theme.palette.grey['400'],
                    mt: '0.5rem',
                }}
            >
                {t('widget.pageBreak')}
            </Typography>
        </WidgetCard>
    );
};

export default PageBreakWidget;
